module.exports = __webpack_public_path__ + "static/media/verygood.f68c8a13.png";